export class Department{
    id: number = 0
    name: string = ''
    phone: string = ''
}